import VueRouter from 'vue-router';

export function initVueRouter (app) {
  const { config } = app;
  const router = new VueRouter(config.router.options);

  config.router.guards.before.forEach(g => router.beforeEach(g));
  config.router.guards.after.forEach(g => router.afterEach(g));

  app.router = router;
}
